import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App as AntApp, ConfigProvider, theme } from "antd";
import enUS from "antd/locale/en_US";

import AppRoutes from "./App";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={enUS}
      theme={{
        token: {
          colorPrimary: "#141414",
          colorLink: "#3b5bdb",
          colorInfo: "#3b5bdb",
          borderRadius: 6,
          borderRadiusSM: 4,
          fontFamily:
            "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
          fontSize: 13,
          fontSizeSM: 12,
          fontSizeLG: 14,
          fontSizeHeading2: 22,
          fontSizeHeading3: 16,
          colorText: "#141414",
          colorTextSecondary: "#474747",
          colorTextTertiary: "#898989",
          colorBorderSecondary: "#ececec",
          colorBorder: "#ececec",
          controlHeight: 30,
          controlHeightSM: 26,
          lineHeight: 1.45,
        },
        components: {
          Table: {
            cellPaddingBlock: 6,
            cellPaddingInline: 10,
            headerBg: "#fbfbfb",
            headerColor: "#474747",
            rowHoverBg: "#f4f4f3",
            fontSize: 13,
            borderColor: "#ececec",
          },
          Button: {
            fontSize: 13,
            paddingInline: 11,
            controlHeight: 28,
          },
          Tag: { fontSize: 12 },
          Input: { controlHeight: 30 },
          Select: { controlHeight: 30 },
        },
        algorithm: theme.defaultAlgorithm,
      }}
    >
      <AntApp>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);
